import './prettify';
import './lang-css';

const prettyPrint = window.prettyPrint;
export { prettyPrint };
